import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  grid: {
    flexDirection: 'column',
    '& .MuiSelect-select': {
      whiteSpace: 'normal',
      padding: '5px 30px 5px 15px',
    },

    [theme.breakpoints.down('xs')]: {
      minHeight: 100,
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      '& p': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 41,
      },
    },
  },
  flex: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paper: {
    width: '100%',
    padding: '25px 60px',
    boxShadow: 'unset',
    textAlign: 'center',
    color: theme.palette.text.secondary,
    background: 'transparent',
    '& label + .MuiInput-formControl': {
      marginTop: 0,
    },
    '& h2': {
      margin: '0 0 15px',
      // fontSize: 32
    },
    '@media(max-width: 440px)': {
      padding: '50px 12px 20px',
    },
  },

  input: {
    boxShadow: '1.7px 1.7px .7px #ffd5ac, -1.7px -1.7px .7px #d8ced7',
    borderRadius: 8,
  },
  fixInput: {
    maxWidth: '152px',
  },

  mainSettingsHeader: {
    color: '#f45f49',
    fontSize: 28, // FS 22 with new font
    fontFamily: 'ChalkCyrillicFreehand, sans-serif !important',
    margin: ' 0 0 10px 0',
  },
  subSettingsHeader: {
    display: 'inline-block',
    color: '#4697a7',
    fontSize: 24,
    fontFamily: 'ChalkCyrillicFreehand, sans-serif !important',
    margin: ' 0 0 10px 0',
  },
  formControl: {
    width: '100%',

    '& .MuiSelect-select.MuiSelect-select': {
      paddingLeft: 20,
      // fontSize: 22,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  inputLabel: {
    whiteSpace: 'nowrap',
  },

  label: {
    fontFamily: 'ChalkCyrillicFreehand, sans-serif !important',
    fontSize: '1em !important',
    whiteSpace: 'nowrap',
    '@media (max-width: 700px)': {
      whiteSpace: 'normal',
    },
  },

  checkbox: {
    transform: 'scale(1.4)',
  },

  disabledField: {
    opacity: '0.5',
    pointerEvents: 'none',
  },
  addSettings: {
    marginBottom: '15px',
  },
}));

export default useStyles;
